import { Delete } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface RemoveEventDialogProps {
  open: boolean;
  handleClose: () => void;
  handleRemove: () => void;
}

const RemoveEventDialog: React.FC<RemoveEventDialogProps> = ({
  open,
  handleClose,
  handleRemove
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="remove-event-dialog-title"
      aria-describedby="remove-event-dialog-description"
      data-testid="remove-event-dialog"
    >
      <DialogTitle
        id="remove-event-dialog-title"
        data-testid="remove-event-dialog-title"
      >
        {t("ROOSTER.PUBLIC-APP.REMOVE_AVAILABILITY", {
          defaultValue: "Remove Availability"
        })}
      </DialogTitle>
      <DialogContent data-testid="remove-event-dialog-content">
        <DialogContentText id="remove-event-dialog-description" fontSize={15}>
          {t("ROOSTER.PUBLIC-APP.REMOVE_SLOT_CONFIRMATION", {
            defaultValue:
              "Do you want to remove the selected slot from your availability?"
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions data-testid="remove-event-dialog-actions">
        <Button
          size="small"
          onClick={handleClose}
          autoFocus
          color="error"
          sx={{ ":disabled": { opacity: 0.8 } }}
          data-testid="remove-event-back-button"
        >
          <ArrowBackIcon />
          &nbsp;{" "}
          {t("ROOSTER.PUBLIC-APP.BACK", {
            defaultValue: "Back"
          })}
        </Button>
        <Button
          size="small"
          onClick={() => {
            handleRemove();
          }}
          color="primary"
          data-testid="remove-event-confirm-button"
        >
          <Delete /> &nbsp;{" "}
          {t("ROOSTER.PUBLIC-APP.REMOVE", {
            defaultValue: "Remove"
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveEventDialog;
